import {RegistrationStatus, RsvpStatusOptions} from '@wix/wix-events-commons-statics/dist/types/enums'

export const isEventExternalRegistration = (event: wix.events.Event) => {
  return event.registration.status === RegistrationStatus.OPEN_EXTERNAL
}

export const isNoResponseEnabled = (event: wix.events.Event) =>
  event.registration.rsvpCollection.config.rsvpStatusOptions === RsvpStatusOptions.YES_AND_NO
